import * as styles from './AvisPartial.css';

const AvisPartial = () => (
  <div className={styles.container}>
    <div
      className='trustpilot-widget'
      data-locale='fr-FR'
      data-template-id='5419b6ffb0d04a076446a9af'
      data-businessunit-id='5df76281f2cae50001be7a0b'
      data-style-height='40px'
      data-style-width='100%'
      data-token='76d9e48f-64ed-4a23-a96e-0b4f7fef35ed'
    >
      <a
        href='https://fr.trustpilot.com/review/lecolefrancaise.fr'
        target='_blank'
        rel='noopener noreferrer'
      >
        Trustpilot
      </a>
    </div>
  </div>
);

export default AvisPartial;
